//@ts-ignore
import { redirect } from "@utils/RedirectUtils";
/**
 * Reads from localStorage the entry pagination and if it exists, sets it to true.
 * @param idx The index of the insertion in a list of insertions
 * */
export var updatePaginationLS = idx => {
  /* Updating fromPagination variable in localStorage */
  var paginationString = localStorage.getItem("pagination");
  if (paginationString) {
    var pagination = JSON.parse(paginationString);
    pagination.fromListing = true;
    pagination.idx = idx;
    localStorage.setItem("pagination", JSON.stringify(pagination));
  }
};
/**
* Handles the insertion click performing the following steps:
* 1) Updates the pagination variable in the localStorage and if it exists set it to true
* 2) Redirect to the insertion url and opens a new tab or not according to the configuration input
* @param {RedirectParams} params
* @param idx The index of the insertion in a list of insertions
* */
export var handleInsertionClick = function handleInsertionClick(params) {
  var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  updatePaginationLS(idx);
  redirect(params);
};